import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth/auth-context';

interface NavItem {
  to: string;
  label: string;
  icon: string;
}

const BASE: NavItem[] = [
  { to: '/app/flights', label: 'Flüge', icon: '✈️' },
  { to: '/app/flights/new', label: 'Neu', icon: '➕' },
  { to: '/app/my-requests', label: 'Anfragen', icon: '📨' },
  { to: '/app/events', label: 'Events', icon: '📅' },
  { to: '/app/members', label: 'Mitglieder', icon: '👥' },
  { to: '/app/settings', label: 'Settings', icon: '⚙️' },
];

const ADMIN: NavItem = { to: '/admin', label: 'Admin', icon: '🛠' };

export function BottomNav() {
  const { isAdmin } = useAuth();
  const items = isAdmin ? [...BASE, ADMIN] : BASE;
  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-20 border-t border-slate-800 bg-slate-900/95 backdrop-blur-md"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <ul
        className="grid"
        style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}
      >
        {items.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center py-3 text-xs gap-0.5 transition-colors ${
                  isActive
                    ? 'text-brand-500'
                    : 'text-slate-400 hover:text-slate-200'
                }`
              }
            >
              <span className="text-lg leading-none" aria-hidden>
                {item.icon}
              </span>
              <span>{item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
